module.exports = __webpack_public_path__ + "media/winter_2025_sweepstakes/2025k-scholarship-success-lock-up-682ad591.jpg";